const lang = {
    '错误': {
        'zh_TW': '錯誤',
        'en_US': 'Error',
    },
    '首页': {
        'zh_TW': '首頁',
        'en_US': 'HOME',
    },
    '进入市场': {
        'zh_TW': '進入市場',
        'en_US': 'Enter The Market',
    },
    '关于我们': {
        'zh_TW': '關於我們',
        'en_US': 'About Us',
    },
    '线上客服': {
        'zh_TW': '線上客服',
        'en_US': 'Customer Service',
    },
    '钱包': {
        'zh_TW': '錢包',
        'en_US': 'wallet',
    },
    '储值': {
        'zh_TW': '儲值',
        'en_US': 'Deposit',
    },
    '提领': {
        'zh_TW': '提領',
        'en_US': 'Pick up',
    },
    '资金记录': {
        'zh_TW': '資金紀錄',
        'en_US': 'Record',
    },
    '用户资讯': {
        'zh_TW': '用戶資訊',
        'en_US': 'User Information',
    },
    '最新公告': {
        'zh_TW': '最新公告',
        'en_US': 'Bulletin',
    },
    '登出': {
        'zh_TW': '登出',
        'en_US': 'Sign Out',
    },
    '帐号': {
        'zh_TW': '帳號',
        'en_US': 'Account',
    },
    '密码': {
        'zh_TW': '密碼',
        'en_US': 'Password',
    },
    '验证码': {
        'zh_TW': '驗證碼',
        'en_US': 'Verification code',
    },
    '忘记密码': {
        'zh_TW': '忘記密碼',
        'en_US': 'Forgot Password',
    },
    '还没有帐号吗': {
        'zh_TW': '還沒有帳號嗎',
        'en_US': "Don't have an account yet",
    },
    '注册': {
        'zh_TW': '註冊',
        'en_US': 'REGISTER',
    },
    '取消': {
        'zh_TW': '取消',
        'en_US': 'Cancel',
    },
    '登入': {
        'zh_TW': '登入',
        'en_US': 'Sign in',
    },
    '密码确认': {
        'zh_TW': '密碼確認',
        'en_US': 'Password Confirmation',
    },
    '姓名': {
        'zh_TW': '姓名',
        'en_US': 'Name',
    },
    '手机号码': {
        'zh_TW': '手機號碼',
        'en_US': 'Mobile Phone',
    },
    '联络方式': {
        'zh_TW': '聯絡方式',
        'en_US': 'Contact',
    },
    '送出': {
        'zh_TW': '送出',
        'en_US': 'Submit',
    },
    '我已年满18岁，且已详读、接受并同意条款与规约、规则、隐私政策、Cookies政策以及年龄验证的相关政策': {
        'zh_TW': '我已年滿 18 歲，並已閱讀、接受並同意條款和條件、規則、隱私政策、Cookie 政策以及與年齡驗證相關的政策',
        'en_US': 'I am over 18 years old and have read, accept and agree to the terms and conditions, rules, privacy policy, cookie policy and policies related to any age verification ',
    },
    '会员': {
        'zh_TW': '會員',
        'en_US': 'User',
    },
    '请输入': {
        'zh_TW': '請輸入',
        'en_US': 'Please enter your ',
    },
    '您必须同意条款和条件': {
        'zh_TW': '您必須同意條款和條件',
        'en_US': 'You must agree to the terms and conditions',
    },
    '开始交易': {
        'zh_TW': '開始交易',
        'en_US': 'Start trading',
    },
    '用户设定': {
        'zh_TW': '用戶設定',
        'en_US': 'User settings',
    },
    '资产管理': {
        'zh_TW': '資產管理',
        'en_US': 'Deposit',
    },
    '优惠活动': {
        'zh_TW': '優惠活動',
        'en_US': 'PROMOTIONS',
    },
    '网站公告': {
        'zh_TW': '網站公告',
        'en_US': 'Bulletin',
    },
    '交易记录': {
        'zh_TW': '交易紀錄',
        'en_US': 'Deposit History',
    },
    '站内讯息': {
        'zh_TW': '站内訊息',
        'en_US': 'Station Message',
    },
    '服务条款': {
        'zh_TW': '服務條款',
        'en_US': 'Terms of service',
    },
    '联系客服': {
        'zh_TW': '聯繫客服',
        'en_US': 'LIVE CHAT',
    },
    '更换密码': {
        'zh_TW': '更換密碼',
        'en_US': 'Change password',
    },
    '旧密码': {
        'zh_TW': '舊密碼',
        'en_US': 'Old Password',
    },
    '新密码': {
        'zh_TW': '新密碼',
        'en_US': 'New Password',
    },
    '确认密码': {
        'zh_TW': '確認密碼',
        'en_US': 'Confirm Password',
    },
    '旧密码错误': {
        'zh_TW': '舊密碼錯誤',
        'en_US': '',
    },
    '成功': {
        'zh_TW': '成功',
        'en_US': 'Success',
    },
    '失败': {
        'zh_TW': '失敗',
        'en_US': 'Error',
    },
    '入金': {
        'zh_TW': '入金',
        'en_US': 'Deposit',
    },
    '提领': {
        'zh_TW': '提領',
        'en_US': 'Withdraw',
    },
    'USDT提领': {
        'zh_TW': 'USDT提領',
        'en_US': 'USDT Withdraw',
    },
    '储值请联系客服，将会有专人为您处理': {
        'zh_TW': '儲值請聯繫客服，將會有專人為您處理',
        'en_US': 'Please contact customer service for stored value, and someone will handle it for you',
    },
    '请新增一组钱包地址': {
        'zh_TW': '請新增一組錢包地址',
        'en_US': 'Please add a set of wallet addresses',
    },
    '交易所/钱包': {
        'zh_TW': '交易所/錢包',
        'en_US': 'Exchange/Wallet',
    },
    '协议': {
        'zh_TW': '協議',
        'en_US': 'Protocol',
    },
    '钱包地址': {
        'zh_TW': '錢包地址',
        'en_US': 'Wallet Address',
    },
    '上传身份证截图': {
        'zh_TW': '上傳身份證截圖',
        'en_US': 'Upload Idcard photo',
    },
    '上传交易所截图': {
        'zh_TW': '上傳交易所截圖',
        'en_US': 'Upload Bank photo',
    },
    '钱包资讯状态': {
        'zh_TW': '錢包資訊狀態',
        'en_US': 'Wallet Information Status',
    },
    '审核中': {
        'zh_TW': '審核中',
        'en_US': 'under review',
    },
    '会员总览': {
        'zh_TW': '會員總覽',
        'en_US': 'Menus',
    },
    '已验证': {
        'zh_TW': '已驗證',
        'en_US': 'Checked',
    },
    '金额': {
        'zh_TW': '金額',
        'en_US': 'Amount',
    },
    '状态': {
        'zh_TW': '狀態',
        'en_US': 'State',
    },
    '限制金额': {
        'zh_TW': '限制金額',
        'en_US': 'Limit amount',
    },
    '手续费': {
        'zh_TW': '手續費',
        'en_US': 'Fee',
    },
    '可用资金不足': {
        'zh_TW': '可用资金不足',
        'en_US': 'Insufficient funds available',
    },
    '储值记录': {
        'zh_TW': '儲值紀錄',
        'en_US': 'Deposit History',
    },
    '提领记录': {
        'zh_TW': '提领紀錄',
        'en_US': 'Withdraw History',
    },
    '交易时间': {
        'zh_TW': '交易時間',
        'en_US': 'transaction hour',
    },
    '细目': {
        'zh_TW': '細目',
        'en_US': 'Detail',
    },
    '待处理': {
        'zh_TW': '待處理',
        'en_US': 'Wating',
    },
    '已取消': {
        'zh_TW': '已取消',
        'en_US': 'Cancelled',
    },
    '已处理': {
        'zh_TW': '已處理',
        'en_US': 'Handled',
    },
    '发送讯息': {
        'zh_TW': '發送訊息',
        'en_US': 'Station Message',
    },
    '发送讯息': {
        'zh_TW': '發送訊息',
        'en_US': 'Send message',
    },
    '建立日期': {
        'zh_TW': '建立日期',
        'en_US': 'Created Date',
    },
    '内容': {
        'zh_TW': '内容',
        'en_US': 'Content',
    },
    '讯息数': {
        'zh_TW': '訊息數',
        'en_US': 'Number of messages',
    },
    '主旨': {
        'zh_TW': '主旨',
        'en_US': 'Subject',
    },
    '回复': {
        'zh_TW': '回覆',
        'en_US': 'Reply',
    },
    '新讯息': {
        'zh_TW': '新訊息',
        'en_US': 'new message',
    },
    '亲爱的会员欢迎您进入娱乐城': {
        'zh_TW': '親愛的會員歡迎您進入娛樂城',
        'en_US': 'Dear visitors welcome you to enter the casino',
    },
    '登入后即享有更多服务内容': {
        'zh_TW': '登入后即享有更多服務内容',
        'en_US': 'Enjoy more service content after login',
    },
    '游戏大厅': {
        'zh_TW': '遊戲大廳',
        'en_US': 'Games Lobby',
    },
    '选择期权': {
        'zh_TW': '選擇期權',
        'en_US': 'BINARY OPTION',
    },
    'BOSS彩票': {
        'zh_TW': 'BOSS彩票',
        'en_US': 'BOSS LOTTERY',
    },
    'BOSS棋牌': {
        'zh_TW': 'BOSS 棋牌',
        'en_US': 'BOSS CHESS',
    },
    '获取验证码': {
        'zh_TW': '獲取驗證碼',
        'en_US': 'Send sms code',
    },
    '验证码已发送': {
        'zh_TW': '驗證碼已發送',
        'en_US': 'Send success',
    },
    '娱乐城所属产品和服务获得菲律宾政府PAGCOR颁发博彩牌照且受其监管': {
        'zh_TW': '娛樂城所屬產品和服務獲得菲律賓PAGCOR頒發離岸博彩執照及第三方平台GLI認證並受監督',
        'en_US': 'The products and services of Fusheng Entertainment and Entertainment have obtained the gaming license issued by the Philippine government PAGCOR and are regulated by it'
    },
    '查看大奖游戏': {
        'zh_TW': '查看大獎遊戲',
        'en_US': 'Look at the big prize game',
    },
    '为您推荐': {
        'zh_TW': '爲您推薦',
        'en_US': 'Recommend for you',
    },
    '真人视讯': {
        'zh_TW': '真人视讯',
        'en_US': 'LIVE CASINO',
    },
    '体育竞赛': {
        'zh_TW': '體育競賽',
        'en_US': 'SPORTS',
    },
    '百家乐': {
        'zh_TW': '百家樂',
        'en_US': 'BACAKEL',
    },
    '银行': {
        'zh_TW': '銀行',
        'en_US': 'BankName',
    },
    '分行': {
        'zh_TW': '分行',
        'en_US': 'CountName',
    },
    '户名': {
        'zh_TW': '戶名',
        'en_US': 'UserName',
    },
    '银行卡号': {
        'zh_TW': '銀行卡號',
        'en_US': 'BankCard',
    },
    '上传存折簿截图': {
        'zh_TW': '上傳存摺簿截圖',
        'en_US': 'Upload bankbook photo',
    },
    '刮刮乐': {
        'zh_TW': '刮刮樂',
        'en_US': 'Scratch',
    },
    '当前可用次数': {
        'zh_TW': '當前可用次數',
        'en_US': 'Current availability',
    },
    '再来一次': {
        'zh_TW': '再來一次',
        'en_US': 'Again',
    },
    '请选择您的提领方式': {
        'zh_TW': '請選擇您的提領方式',
        'en_US': 'Please choose your withdrawal method',
    },
    '在线人数': {
        'zh_TW': '在線人數',
        'en_US': 'onLine',
    }

}


export default lang;


// WEBPACK FOOTER //
// ./src/utils/i18n.js